var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipLoader5M3Ld5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 841.9 595.3"
    },
    viewBox: "97 145 682 322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .Skip_Loader_5m3_LD5_svg__st0{fill:currentColor}.Skip_Loader_5m3_LD5_svg__st1{opacity:.4}.Skip_Loader_5m3_LD5_svg__st1,.Skip_Loader_5m3_LD5_svg__st2{fill:#1d1d1b;enable-background:new}.Skip_Loader_5m3_LD5_svg__st5{enable-background:new}.Skip_Loader_5m3_LD5_svg__st2{opacity:.1}.Skip_Loader_5m3_LD5_svg__st5{opacity:.3;fill:#040506}.Skip_Loader_5m3_LD5_svg__st8{opacity:.1;fill:#fff}.Skip_Loader_5m3_LD5_svg__st12,.Skip_Loader_5m3_LD5_svg__st19,.Skip_Loader_5m3_LD5_svg__st8{enable-background:new}.Skip_Loader_5m3_LD5_svg__st12{opacity:.2;fill:#fff}.Skip_Loader_5m3_LD5_svg__st19{fill:#030405;opacity:.2}.Skip_Loader_5m3_LD5_svg__st26{opacity:.2}.Skip_Loader_5m3_LD5_svg__st28{opacity:.3;fill:#030405}.Skip_Loader_5m3_LD5_svg__st29{fill:#fff}.Skip_Loader_5m3_LD5_svg__st30{opacity:.2;fill:#040506}\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    width: "100%",
    height: "100%",
    viewBox: "0 0 331 284"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 331,
    height: 284,
    href: ""
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_5m3_LD5_svg__Container_5_00000038391759162406128970000007455726351044530083_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Bakgrund_00000017492420807682123500000006069092602055209104_",
    d: "M97.5 288v56.7l373 121.9L600 421.5l5.8 1.6h.3c.1 0 .3.1.4.1.3 0 .5 0 .8-.1.7-.2 1.3-.4 1.9-.6 1.2-.4 1.9-1.5 1.9-2.8v-.7l8.8-3.1 3.6 1c.6.1 1.2.1 1.7-.1.5-.1 1-.3 1.5-.5 1.2-.4 2.1-1.5 2.1-2.8v-2.1l95.2-33.2v-14l-6.2-1.4 15.4-56.1 17.2-5 4-12.4-10.4-7-4.5 1.2 4.5-1.2-4-.7 15.4-56.1 19.7-4.5 4-12.3-10.4-7-4.4-.6-429-56-4.8.5-233 27.3v99.4",
    className: "Skip_Loader_5m3_LD5_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_60_x25__00000039827425665774274770000005647443001179812763_",
    d: "m120.4 173.2 214.5-24.6.3 62.7-214.8-38.1z",
    className: "Skip_Loader_5m3_LD5_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_40_x25__00000015318653806442499310000004859653531299043989_",
    d: "m334.9 148.6.3 62.7 205.3 36.4L754 204.6l-419.1-56z",
    className: "Skip_Loader_5m3_LD5_svg__st2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Skip_Loader_5m3_LD5_Logo",
    transform: "translate(93.4,157.1)",
    d: "m45.655 116.67h219.82v104.27h-219.82z",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_20_x25__00000069380567491394773480000016634351451991759272_",
    transform: "translate(213.255 45.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25343_00000098942174483699559880000000346280913334836661_",
    d: "m318.4 224 7.9 5.2 216-49-15.6 55.8-.5 2.4-232.7 63.4 24.9-77.8z",
    className: "Skip_Loader_5m3_LD5_svg__st19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25344_00000076585269359903786000000004629874174977699503_",
    d: "m287.1 321.6-25.7 78.9 117.5-38.6 10.6-32.6 29.3-8.9 1 .3-4 12.5v16l88.3-29.6 16.1-58.5-225.3 65.6-7.8-5.1z",
    className: "Skip_Loader_5m3_LD5_svg__st19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_10_x25__00000078019407078904076910000007358110428575288967_",
    d: "m512.8 357.4-4.8 14.7 242.5-70.4 3.9-12.5-241.6 68.2z",
    className: "Skip_Loader_5m3_LD5_svg__st28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_20_x25__00000161631119073813898770000015383465372338399145_",
    d: "m544.4 259.8-4.8 14.8L775.2 221l4-12.2-234.8 51z",
    className: "Skip_Loader_5m3_LD5_svg__st28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Highlight_10_x25__00000023971748678994247930000013652847480100030887_",
    d: "m97.5 288-.2 56.7 373.1 121.6-.2-16.5-139.8-44.3.2-83.8 164.5 41.8 12.7 8.6 4.8-14.7-12.5-8.5L348 311.1 330.5 282v-52.6l197.4 37.4 11.8 7.7 4.8-14.8-16-9.2-431.2-77.7.2 99.5V288zM319 227.1l-.2 50.3c-1.9 1-2.8 3.1-2.3 5.1.2 1.6 1 3 2.3 3.9l.1 17.9-114.7-28.2-.2-70.9 115 21.9zm-127.1 21.4c-1.7.4-2.5 2.9-2 5.5.2.9.6 1.8 1.1 2.6l-.1.2-8.2 14.1-74.7-18.4.2-65.2 85.9 16.1.1 44.5-2.3.6m-83.8 26.9v-10.6l85.8 22 .7 75.5-86.3-27.1-.3-44.1.1-15.7m95.7 90.4.2-76.6 114.7 29.6.5 83.3-115.4-36.3z",
    className: "Skip_Loader_5m3_LD5_svg__st8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_20_x25__00000179610466937731489630000007861944957775592345_",
    transform: "translate(285.249 148.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25345_00000118364366307930144180000004977529340807506339_",
    d: "M320.9 271.6c-.4.2-.8.3-1.2.4l.2-.2v-.1c.6-.8.8-1.9.4-2.9-.2-1.4-1.6-2.4-3-2.2-.1 0-.3.1-.4.2h-.1c-.1 0-.1.1-.2.1.2-.2.5-.4.8-.5.5-.2 1-.4 1.5-.5 1.2.1 2.2.9 2.6 2 .8 1.3.5 2.8-.6 3.7z",
    className: "Skip_Loader_5m3_LD5_svg__st19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25346_00000112609273346311902770000011471517898098402743_",
    d: "m326 263.3 10.9-3.6c1.3-.1 2.4.7 2.8 1.9.6 1.1.5 2.4-.3 3.4-.2.2-.4.3-.7.5-.2.1-12.8 4.6-12.8 4.6l.1-6.8z",
    className: "Skip_Loader_5m3_LD5_svg__st19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_5m3_LD5_svg__Highlight_20_x25__00000159441481062799031900000003937875030071076993_",
    transform: "translate(6.097 59.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25347_00000013154334235721675240000012875656535006442382_",
    d: "m102 192.5 6.6-1.1 69.5 17.2-1.4 2.3-74.7-18.4z",
    className: "Skip_Loader_5m3_LD5_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25348_00000002361715677196306890000002243103211708586382_",
    d: "m198.2 216.1 6.3-1.4 108.2 26.6.2 3-114.7-28.2z",
    className: "Skip_Loader_5m3_LD5_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25349_00000158006911755230848870000013592450983415143809_",
    d: "m342.1 251.2 6-1.5 152.6 37.5-6.5 1.8-152.1-37.8z",
    className: "Skip_Loader_5m3_LD5_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25350_00000044153252836447719030000009198546207886262447_",
    d: "m324.4 345.6 7.1-2.1 139.6 43.9-7 2.4-139.7-44.2z",
    className: "Skip_Loader_5m3_LD5_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25351_00000160178125404852216880000015659285485442741396_",
    d: "m197.7 305.9 6.6-1.9 108.5 34 .3 4.2-115.4-36.3z",
    className: "Skip_Loader_5m3_LD5_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25352_00000131362706011008127930000006509965922489073820_",
    d: "m102.2 275.3 6.1-1.2 79.8 24.7.4 3.5-86.3-27z",
    className: "Skip_Loader_5m3_LD5_svg__st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_5m3_LD5_svg__Highlight_20_x25__00000132086296639049936760000013690242687546241165_",
    className: "Skip_Loader_5m3_LD5_svg__st26",
    transform: "translate(210.79 123.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25353_00000144298036743417698550000004290584765131224239_",
    d: "M259.5 326 389 282.6l.3 15.1-129.6 44.8-.2-16.5z",
    className: "Skip_Loader_5m3_LD5_svg__st29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Path_25354_00000127034214398506832660000007557259220497629366_",
    d: "m382.9 283.4 4.7-1.5 10.9-28.7.2 41.5c0 1.6-.5 3.1-1.5 4.3 0 0 .3-.1.8-.3.7-.2 1.3-.6 1.7-1.2.3-.4.4-.8.5-1.3v-1c0-1.6.1-6.7.1-6.7l6.5-2.1-.1-10.2-6.5 2.2v-.9l5-1.8 10.8-28.4.2 41.1c0 1.2-.3 2.3-.8 3.3l-.6 1c.5-.1.9-.3 1.3-.5.2-.1.4-.2.5-.3.3-.2.5-.5.7-.7.3-.4.4-.8.5-1.3.1-.8.1-1.6 0-2.4l95.2-33.2v-13.9l-95 32.3-.1-17.8 4-12.5-29.1 9.2-9.9 31.8z",
    className: "Skip_Loader_5m3_LD5_svg__st29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Skip_Loader_5m3_LD5_svg__Ellipse_672_00000013875116589929738410000012300814961155469729_",
    cx: 392.7,
    cy: 294.6,
    className: "Skip_Loader_5m3_LD5_svg__st12",
    rx: 2.2,
    ry: 3,
    transform: "rotate(-16.799 392.752 294.64)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_10_x25__00000040563547072091376830000011572017299044233635_",
    d: "m500.3 349 239.2-65.2.5-2.4 4.1.9 10.3 6.9-241.6 68.2-12.5-8.4z",
    className: "Skip_Loader_5m3_LD5_svg__st8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skip_Loader_5m3_LD5_svg__Skugga_20_x25__00000152969131539030966360000005014979688953660308_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.4 279.2h-.6c-.5-1.1-1.4-1.9-2.5-2.3-.4-.1-.7-.1-1.1 0l-.4.1-1.7.4c.3-.1.6-.1.9 0 1.8.4 3.2 2.8 3.2 5.4 0 2.1-.9 3.6-2.3 3.9h.1l2.2-.5c1.3-.2 2.2-1.6 2.3-3.5h.2c.5-.1.8-.7.8-1.4.2-1-.3-1.8-1.1-2.1zm-127.7-28.9h-.6c-.5-1.1-1.4-1.9-2.5-2.3-.4-.1-.7-.1-1.1 0l-.4.1-1.7.4c.3-.1.6-.1.9 0 1.8.4 3.2 2.8 3.2 5.4 0 2.1-.9 3.6-2.3 3.9h.1l2.2-.5c1.3-.2 2.2-1.6 2.3-3.5h.2c.5-.1.8-.7.8-1.4.2-.9-.3-1.7-1.1-2.1z",
    className: "Skip_Loader_5m3_LD5_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.5 188.5-6.2-1.2-.2 64.9 6.4-1.1zm90 87.4 6.1-1.3.3-67.9-6.8-1.5zm131.9 4.3 1.1-49.4-7-1.3V282l17.7 29.2 5.8-1.5zm-5.7 41.5-.4 83.8 6.9-2-.1-80.1zm-126.9 44.1 6.6-1.9.3-72.6-6.7-2.2zm-95.7-101 .2 70.4 6.1-1.1-.8-67.7z",
    className: "Skip_Loader_5m3_LD5_svg__st30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Skip_Loader_5m3_LD5_svg__Highlight_20_x25_",
    d: "m754 204.6 14.8-2.8-433.4-56.6-238.1 27.6 431.1 77.7 12.1-2.8-420.1-74.5 214.5-24.6z",
    className: "Skip_Loader_5m3_LD5_svg__st12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.4 250.5 16 9.3 234.8-51-10.4-7z",
    className: "Skip_Loader_5m3_LD5_svg__st8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipLoader5M3Ld5);
export default __webpack_public_path__ + "static/media/Skip_Loader_5m3_LD5.7fb6186fee38f612593a1bfbe14d049a.svg";
export { ForwardRef as ReactComponent };